import { SolidZhk16, UIText3 } from '@cian/ui-kit';
import * as React from 'react';

import * as style from './style.css';

export const NewbuildingPremiumBuilderLabel: React.FC = () => {
  return (
    <div className={style['label']}>
      <SolidZhk16 color="primary_100" />
      <UIText3 color="black_100">Надежный застройщик</UIText3>
    </div>
  );
};
